import React, { ForwardedRef } from 'react';

import InputCheckbox, { IInputCheckboxProps } from './Checkbox';
import InputDefault, { IDefaultInputProps } from './Default';
import InputTime, { IInputTimeProps } from './Time';

export type InputTypesProps = Partial<IInputTimeProps> &
  Partial<IInputCheckboxProps> &
  Partial<IDefaultInputProps> & { ref: ForwardedRef<HTMLInputElement> };

export function inputTypes(props: InputTypesProps) {
  return {
    time: <InputTime {...(props as IInputTimeProps)} />,
    toggle: <InputCheckbox {...(props as IInputCheckboxProps)} />,
    default: <InputDefault {...(props as IDefaultInputProps)} />,
  };
}
